import { render, staticRenderFns } from "./00drugList.vue?vue&type=template&id=18a3456a&"
import script from "./00drugList.vue?vue&type=script&lang=js&"
export * from "./00drugList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports